import {
	overrideServiceListStyleParams,
	BOOKINGS_APP_DEF_ID,
	SERVICE_LIST_PAGE_ID,
	SERVICE_LIST_WIDGET_ID,
} from '@wix/bookings-style-params-overrides'
import { resolveAppSettings } from './resolveAppSettings'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'

export const overrideStyleParams = ({
	styleParams,
	referenceId,
	widgetId,
	widgetsWithAppSettings,
	tpaData,
	isResponsive,
	anywhereThemeOverride,
}: {
	styleParams: any
	referenceId: string | undefined
	widgetId: string
	widgetsWithAppSettings: Map<string, any> | undefined
	tpaData: any
	isResponsive: boolean
	anywhereThemeOverride?: string
}) => {
	const appSettings = widgetsWithAppSettings?.get(`${widgetId}-${referenceId}`)
	// @ts-ignore
	const overrideStyleParamsForWidget = getOverrideStyleParamsFnForWidget(widgetId)
	styleParams = overrideStyleParamsForWidget({
		appSettings,
		isResponsive,
		tpaData,
		styleParams,
		anywhereThemeOverride,
	})
	return styleParams
}

const widgetsWithStyleParamsOverrides = {
	[SERVICE_LIST_PAGE_ID]: {
		appDefinitionId: BOOKINGS_APP_DEF_ID,
		overrideStyleParamsFn: overrideServiceListStyleParams,
	},
	[SERVICE_LIST_WIDGET_ID]: {
		appDefinitionId: BOOKINGS_APP_DEF_ID,
		overrideStyleParamsFn: overrideServiceListStyleParams,
	},
}

export const shouldOverrideStyleParams = (widgetId: string): boolean => {
	return Object.keys(widgetsWithStyleParamsOverrides).includes(widgetId)
}

const getAppDefIdForWidget = (widgetId: keyof typeof widgetsWithStyleParamsOverrides) => {
	return widgetsWithStyleParamsOverrides[widgetId].appDefinitionId
}

const getOverrideStyleParamsFnForWidget = (widgetId: keyof typeof widgetsWithStyleParamsOverrides) => {
	return widgetsWithStyleParamsOverrides[widgetId].overrideStyleParamsFn
}

const getAppsInstalled = (clientSpecMap: any) => {
	return Object.values(clientSpecMap).map((installedApplication: any) => {
		return {
			appDefinitionId: installedApplication.appDefinitionId,
			instanceId: installedApplication.instanceId,
		}
	})
}

export const resolveWidgetsWithAppSettings = async (
	widgetsWithReferenceId: Array<{ widgetId: string; referenceId: string }> | undefined,
	clientSpecMap: any,
	metricsReporter: MetricsReporter
) => {
	const widgetsWithAppSettings = new Map<string, any>()
	if (widgetsWithReferenceId?.length) {
		const appsInstalled: Array<{ appDefinitionId: string; instanceId: string }> = getAppsInstalled(clientSpecMap)
		await Promise.all(
			widgetsWithReferenceId.map(async (widget) => {
				const { widgetId, referenceId } = widget
				if (shouldOverrideStyleParams(widgetId)) {
					// @ts-ignore
					const appDefinitionId = getAppDefIdForWidget(widgetId)
					const instanceId = appsInstalled.find(
						(appInstalled) => appInstalled.appDefinitionId === appDefinitionId
					)?.instanceId
					const appSettings = await resolveAppSettings(
						referenceId,
						appDefinitionId,
						// @ts-ignore
						instanceId,
						metricsReporter
					)
					widgetsWithAppSettings.set(`${widgetId}-${referenceId}`, appSettings)
				}
			})
		)
	}
	return widgetsWithAppSettings
}
